import { BLANK_VALUE } from 'common/constants/general';
import { ICell } from 'models/interfaces/spreadsheet-types/core-types';
import { isExpression } from 'utilities';


export interface Change<T extends ICell> {
  cell: T;
  value: string | null;
}

const sanitizeCellValue = <T extends ICell>(change: Change<T>) => {
  // If the new value is an empty string and the cell has a valid expression
  // we need to set the value to the expression to prevent the cell from
  // displaying the formula as a string.
  if (change.value === BLANK_VALUE && isExpression(String(change.cell.defaultExpr || ''))) {
    return { ...change, value: change.cell.defaultExpr } as Change<T>;
  }
  return change;
};

export default sanitizeCellValue;
